import { InjectionToken } from '@angular/core';

export const SERVICES_CUSTOMER_TOKEN = new InjectionToken<() => string>('SERVICES_CUSTOMER_TOKEN');
